<template>

  <div>
    <div v-if="deal" class="buymodal-block__body">
      <div class="body-info">
        <div class="body-info__block">
          <div class="info-result" role="status">
            <img src="@/../static/img/icons/galka.svg">
            <div class="info-result__title">Заявка {{ model.btag }} успешно создана!</div>
            <div class="info-result__title">Для продолжения оформления вернитесь в 1С!</div>
            <div v-if="newOrder && newOrder.signContract" class="info-result__signcontract">
              <a :href="newOrder.signContract" target="_doc" class="btn next" style="text-decoration: none">Договор</a>
            </div>
            <div v-if="newOrder && newOrder.shopdoc" class="info-result__btn">
              <a :href="newOrder.shopdoc" target="_print" class="btn next" style="text-decoration: none">Товарная накладная</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="newOrder && !deal">
            <div v-if="user.flowType == 'default'"
        class="buymodal-block__body">

        <div
          class="body-info">
          <div
            class="body-info__block">
            <div
              class="info-result" v-if="!manual && (user && user.orgName != 'MVM')">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              
                Распечатайте товарную накладную и положите её с телефоном<br></div>
                <div
                v-if="newOrder.shopdoc"
                class="info-result__btn">
                <a
                  :href="newOrder.shopdoc"
                  target="_print"
                  class="btn next"
                  style="text-decoration: none">
                  Напечатать
                </a>
              </div>
              <div
                class="info-result__title">
                Для продолжения оформления считайте штрих-код в 1С</div>

                <barcode class="barcode" v-bind:value="model.btag" format="CODE128" background="rgba(255,255,255,0)" displayValue="true" height="80">
                 </barcode>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Товарная накладная:</b></div>
                <div><a :href=newOrder.shopdoc  target="_doc">{{newOrder.shopdoc}}</a></div>
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="manual">
              <div
                class="info-result__title">

                Договор по заявке {{ model.btag }} успешно подписан!
                <br>Осталось сделать несколько шагов:
                </div>
                <div class="info-result__signcontract">
                  <v-checkbox :disabled="checkbox2" v-model="checkbox1" color="primary" label="Провести покупку через кассу"></v-checkbox>
                  <p v-if="!checkbox1">Тут ссылка на инструкцию как проводить через кассу</p>
                  <v-checkbox :disabled="!checkbox1 || checkbox3" v-model="checkbox2" color="primary" label="Сделать фото или скан чека"></v-checkbox>
                  <v-checkbox :disabled="!checkbox2 || checkbox4" v-model="checkbox3" color="primary" label="Отправить фото или скан чека в наш telegram бот"></v-checkbox>
                  <p v-if="!checkbox3 && checkbox2">Уникальная ссылка на бота: <a target="_blank" :href="'https://t.me/tkitradein_bot?start=' + model.btag">https://t.me/tkitradein_bot?start={{model.btag}}</a></br>
                  QR код для перехода в бота:
                  <qr-code :text="'https://t.me/tkitradein_bot?start=' + model.btag"></qr-code></p>
                  <v-checkbox :disabled="!checkbox3" v-model="checkbox4" color="primary" label="Распечать товарную накладную и положить её вместе с устройство"></v-checkbox>
                  
                </div>
                <div
                  v-if="newOrder.shopdoc"
                  class="info-result__btn">
                  <a
                    :href="newOrder.shopdoc"
                    target="_print"
                    class="btn next"
                    style="text-decoration: none">
                    Товарная накладная
                  </a>
                </div>
                <div
                v-if="newOrder.signContract"
                class="info-result__btn">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Товарная накладная:</b></div>
                <div><a :href=newOrder.shopdoc target="_doc">{{newOrder.shopdoc}}</a></div>
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MVM'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MTS'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
          </div>
        </div>

        
      </div>

            <div v-if="user.flowType == 'mvm'"
        class="buymodal-block__body">

        <div
          class="body-info">
          <div
            class="body-info__block">
            <div
              class="info-result" v-if="!manual && (user && user.orgName != 'MVM')">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              
              </div>
              <!-- <div
                class="info-result__title">
                Для продолжения оформления вернитесь в ваш личный кабинет</div> -->

                <!-- <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div> -->
            </div>
            <div
              class="info-result" v-if="manual">
              <div
                class="info-result__title">

                Договор по заявке {{ model.btag }} успешно подписан!
                <br>Осталось сделать несколько шагов:
                </div>
                <div class="info-result__signcontract">
                  <v-checkbox :disabled="checkbox2" v-model="checkbox1" color="primary" label="Провести покупку через кассу"></v-checkbox>
                  <p v-if="!checkbox1">Тут ссылка на инструкцию как проводить через кассу</p>
                  <v-checkbox :disabled="!checkbox1 || checkbox3" v-model="checkbox2" color="primary" label="Сделать фото или скан чека"></v-checkbox>
                  <v-checkbox :disabled="!checkbox2 || checkbox4" v-model="checkbox3" color="primary" label="Отправить фото или скан чека в наш telegram бот"></v-checkbox>
                  <p v-if="!checkbox3 && checkbox2">Уникальная ссылка на бота: <a target="_blank" :href="'https://t.me/tkitradein_bot?start=' + model.btag">https://t.me/tkitradein_bot?start={{model.btag}}</a></br>
                  QR код для перехода в бота:
                  <qr-code :text="'https://t.me/tkitradein_bot?start=' + model.btag"></qr-code></p>
                  <v-checkbox :disabled="!checkbox3" v-model="checkbox4" color="primary" label="Распечать товарную накладную и положить её вместе с устройство"></v-checkbox>
                  
                </div>
                <div
                  v-if="newOrder.shopdoc"
                  class="info-result__btn">
                  <a
                    :href="newOrder.shopdoc"
                    target="_print"
                    class="btn next"
                    style="text-decoration: none">
                    Товарная накладная
                  </a>
                </div>
                <div
                v-if="newOrder.signContract"
                class="info-result__btn">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Товарная накладная:</b></div>
                <div><a :href=newOrder.shopdoc target="_doc">{{newOrder.shopdoc}}</a></div>
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MVM'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MTS'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
      
            <div v-if="user.flowType == 'mts'"
        class="buymodal-block__body">

        <div
          class="body-info">
          <div
            class="body-info__block">
            <div
              class="info-result" v-if="!manual && (user && user.orgName != 'MVM')">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              
              </div>
              <!-- <div
                class="info-result__title">
                Для продолжения оформления вернитесь в ваш личный кабинет</div> -->

                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="manual">
              <div
                class="info-result__title">

                Договор по заявке {{ model.btag }} успешно подписан!
                <br>Осталось сделать несколько шагов:
                </div>
                <div class="info-result__signcontract">
                  <v-checkbox :disabled="checkbox2" v-model="checkbox1" color="primary" label="Провести покупку через кассу"></v-checkbox>
                  <p v-if="!checkbox1">Тут ссылка на инструкцию как проводить через кассу</p>
                  <v-checkbox :disabled="!checkbox1 || checkbox3" v-model="checkbox2" color="primary" label="Сделать фото или скан чека"></v-checkbox>
                  <v-checkbox :disabled="!checkbox2 || checkbox4" v-model="checkbox3" color="primary" label="Отправить фото или скан чека в наш telegram бот"></v-checkbox>
                  <p v-if="!checkbox3 && checkbox2">Уникальная ссылка на бота: <a target="_blank" :href="'https://t.me/tkitradein_bot?start=' + model.btag">https://t.me/tkitradein_bot?start={{model.btag}}</a></br>
                  QR код для перехода в бота:
                  <qr-code :text="'https://t.me/tkitradein_bot?start=' + model.btag"></qr-code></p>
                  <v-checkbox :disabled="!checkbox3" v-model="checkbox4" color="primary" label="Распечать товарную накладную и положить её вместе с устройство"></v-checkbox>
                  
                </div>
                <div
                  v-if="newOrder.shopdoc"
                  class="info-result__btn">
                  <a
                    :href="newOrder.shopdoc"
                    target="_print"
                    class="btn next"
                    style="text-decoration: none">
                    Товарная накладная
                  </a>
                </div>
                <div
                v-if="newOrder.signContract"
                class="info-result__btn">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Товарная накладная:</b></div>
                <div><a :href=newOrder.shopdoc target="_doc">{{newOrder.shopdoc}}</a></div>
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MVM'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
            <div
              class="info-result" v-if="user && user.orgName == 'MTS'">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              </div>
              </br>
                <div
                v-if="newOrder.signContract"
                class="info-result__signcontract">
                <a
                  :href="newOrder.signContract"
                  target="_doc"
                  class="btn next"
                  style="text-decoration: none">
                  Договор
                </a>
              </div>
              <div class="links">
                <div><b>Подписанный договор:</b></div>
                <div><a :href=newOrder.signContract  target="_doc">{{newOrder.signContract}}</a></div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </div>
    <div v-else-if="!deal">
      <div v-if="user.flowType == 'mts'"
        class="buymodal-block__body">

        <div
          class="body-info">
          <div
            class="body-info__block">
            <div
              class="info-result" v-if="!manual && (user && user.orgName != 'MVM')">
              <img
                src="@/../static/img/icons/galka.svg" >
                
              <div
                class="info-result__title">
                Заявка {{ model.btag }} успешно создана!<br>
              
              </div>
              <div
                class="info-result__title">
                Для продолжения оформления вернитесь в 1С!</div>
              </div>
            </div>
          </div>
        </div>

        
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VueBarcode from 'vue-barcode';
export default {
  components: {
    'barcode': VueBarcode
  },
  computed: {
    ...mapState('buyphones', ['model', 'newOrder', 'clientInfo', 'manual', 'deal']),
    ...mapState('user', ['user']),
  },
  data() {
    return {
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      checkbox4: false,
      flowType: null,
    }
  },
  beforeMount() {
    const flowType = this.$storage.get('flowType')
    this.flowType = flowType ? flowType : 'default'
  },
  mounted() {
    if (!this.newOrder && !this.deal)
      if (this.clientInfo){
        this.updateOrder({
        btag: this.model.btag,
        data: {
          client: {
            name: this.clientInfo.lastname + ' ' + this.clientInfo.firstname + ' ' + this.clientInfo.patronymic,
            passportNumber: "",
            passportSerial: this.clientInfo.passportserial,
            passportIssued: this.clientInfo.passportwho,
            passportDate: this.clientInfo.passportdate.replace(/\./g, ''),
            address: this.clientInfo.address,
            email: this.clientInfo.email,
            phone: this.clientInfo.telefon.replace(/\+/g, ''),
            birthday: this.clientInfo.date.replace(/\./g, ''),
          }
        }
      });
      }
      
  },
  methods: {
    ...mapActions('buyphones', ['updateOrder']),
  }
}
</script>
